import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";

export default function AdminContacts() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api
      .get("/contact")
      .then((r) => setItems(r.data || []))
      .catch(() => toast.error("Failed to load contacts."))
      .finally(() => setLoading(false));
  }, []);
  return (
    <div data-testid="admin-contacts">
      <div className="font-mono-accent text-[10px] uppercase text-[#4A5550]">◆ Contact Messages</div>
      <h1 className="font-display font-black uppercase tracking-tighter text-3xl md:text-5xl mb-8 mt-1">
        Contacts ({items.length})
      </h1>
      {loading ? (
        <div className="font-mono-accent text-sm">Loading…</div>
      ) : items.length === 0 ? (
        <div className="border-2 border-[#122A1E] bg-[#EAEAE5] p-8 text-center text-[#4A5550]">
          No contact messages yet.
        </div>
      ) : (
        <div className="grid gap-4">
          {items.map((c) => (
            <article key={c.id} className="border-2 border-[#122A1E] bg-[#F4F4F1] p-6" data-testid={`contact-${c.id}`}>
              <div className="flex flex-wrap items-baseline justify-between gap-3 mb-3">
                <div>
                  <div className="font-display font-black uppercase">{c.full_name}</div>
                  <div className="font-mono-accent text-[10px] uppercase text-[#4A5550]">
                    {new Date(c.created_at).toLocaleString("en-CA")}
                  </div>
                </div>
                {c.subject && (
                  <span className="font-mono-accent text-[10px] uppercase bg-[#122A1E] text-white px-2 py-1">
                    {c.subject}
                  </span>
                )}
              </div>
              <div className="text-sm">
                <a className="text-[#FF5A00] underline" href={`mailto:${c.email}`}>{c.email}</a>
                {c.phone && <span className="ml-3 text-[#4A5550]">{c.phone}</span>}
              </div>
              <p className="mt-3 text-sm whitespace-pre-wrap text-[#4A5550]">{c.message}</p>
            </article>
          ))}
        </div>
      )}
    </div>
  );
}
